export default "__VITE_ASSET__jZ9cU1LEbzRmEgHwK8PQ0g__"